import { Component } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams } from 'ionic-angular';

import { Data } from '../../providers/providers';
import { Location } from '../../models/location';
import { SprayRecord } from "../../models/spray-record";
import { SprayRecordEditPage } from "../spray-record-edit/spray-record-edit";
import {AboutSprayRecordsPage} from "../about-spray-records/about-spray-records";
import {Observable} from "rxjs/index";

@Component({
  selector: 'page-spray-record-list',
  templateUrl: 'spray-record-list.html'
})
export class SprayRecordListPage {

  location: Location;
  sprayRecords: Observable<SprayRecord[]>;

  constructor(public navCtrl: NavController,
              public modalCtrl: ModalController,
              private alertCtrl: AlertController,
              navParams: NavParams,
              public data: Data)
  {
    const self = this;
    this.location = navParams.get('location');
    this.sprayRecords = data.getSprayRecordsCollection(this.location).valueChanges();
  }

  getStageLabel(stage) {
    return SprayRecord.stageLabels[stage];
  }

  editSprayRecord(sprayRecord: SprayRecord) {
    let editModal = this.modalCtrl.create(SprayRecordEditPage, {sprayRecord: sprayRecord});

    editModal.onDidDismiss(record => {
      // record is not set if user cancelled modal
      if (record) {
        console.log(record);
        this.data.updateSprayRecord(this.location, record);
      }
    });
    editModal.present();
  }

  addSprayRecord() {
    let addModal = this.modalCtrl.create(SprayRecordEditPage);
    addModal.onDidDismiss(record => {
      if (record) {
        this.data.addSprayRecord(this.location, record);
      }
    })
    addModal.present();
  }

  deleteSprayRecord(record: SprayRecord) {
    let alert = this.alertCtrl.create({
      title: 'Confirm deletion',
      message: 'Permanently delete this Spray Record?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        },
        {
          text: 'Delete',
          handler: () => {
            this.data.removeSprayRecord(this.location, record);
          }
        }
      ]
    });
    alert.present();
  }

  openAbout() {
    this.navCtrl.push(AboutSprayRecordsPage, {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/spray-record-list/spray-record-list.ts